import { useMediaQuery } from 'react-responsive'

export const useIsMobileQuery = () => useMediaQuery({
  query: '(max-width: 430px)'
})

export const useIsTabletOrMobile = () => useMediaQuery({
  query: '(min-width: 430px) and (max-width: 755px)'
})
